<script>
import { ElMessage } from "element-plus";
import axios from "axios";
import SparkMD5 from "spark-md5";
import { v4 as uuid4v } from "uuid";
import { useStore } from "vuex";
import mainMap from "./map/index.vue";
export default {
  components: {
    mainMap,
  },
  data() {
    return {
      tagAddVisible: false,
      jobVisible: false,
      conAddVisible: false,
      store: useStore(),
      isZ: false,
      jobs: [],
      jobItem: {
        id: "",
        name: "",
        momey: "",
        site: "",
        exerience: "",
        xueli: "",
        content: "",
        demand: "",
        tags: [],
        descriptions: [],
      },
      conItem: {
        title: "",
        text: "",
      },
      tagItem: "",
      joinFrom: {
        name: "",
        contact: "",
        file: "",
      },
      fileDate: {
        MD5: "",
        attachNo: "",
        oldId: "",
        oldPath: "",
        status: "",
        id: "",
      },
      inner_width: 1020,
      fileList: [],
      attachNo: "",
      rules2: {
        name: [{ required: true, message: "请输入您名称", trigger: "blur" }],
        contact: [
          { required: true, message: "请输入您的联系方式", trigger: "blur" },
          { pattern: /^1[3456789]\d{9}$/, message: "请输入正确的号码", trigger: "blur" },
        ],
      },
      // 提交数据到接口
      isKK: true,
      name: "",
      site: "",
      phone: "",
      email: "",
    };
  },
  mounted() {
    this.inner_width = document.querySelector(".jobPost").offsetWidth;
    this.attachNo = uuid4v();
    const user = this.store.state.userInfo;
    this.isZ = user ? (user.permission ? user.permission == 0 : false) : false;
    const host = window.location.host;
    this.isKK = host.includes("fjkkauto");
    this.name = this.isKK ? "福建科控自动化科技有限公司" : "北京凯创通达科技有限公司";
    this.site = this.isKK ? "福建省漳州市芗城区嘉宏广场" : "北京副中心CBD中央商务区";
    this.phone = this.isKK ? "18759688095" : "13011801198";
    this.email = this.isKK ? "fjkkauto@163.com" : "bjkctd@163.com";
    this.queryJobs();
  },
  methods: {
    openAddJop(id) {
      if (id) {
        this.getJobDetail(id);
      } else {
        this.jobItem = {
          id: "",
          name: "",
          momey: "",
          site: "",
          exerience: "",
          xueli: "",
          content: "",
          demand: "",
          tags: [],
          descriptions: [],
        };
      }
      this.jobVisible = true;
    },
    openAddTag() {
      this.tagAddVisible = true;
    },
    openAddCon() {
      this.conAddVisible = true;
    },
    subTag() {
      if (!this.tagItem) {
        ElMessage.error("没有填写标签，无法添加！");
        return;
      }
      if ((this, this.jobItem.tags.length >= 9)) {
        ElMessage.error("标签添加已达上限！");
        return;
      }
      this.jobItem.tags.push(this.tagItem);
      this.tagAddVisible = false;
      this.tagItem = "";
    },
    deleteTag(str) {
      this.jobItem.tags = this.jobItem.tags.filter((i) => i !== str);
    },
    submitTagItem() {
      if (!this.conItem.title || !this.conItem.text) {
        ElMessage.error("没有填写标题或内容描述，无法添加！");
        return;
      }
      const texts = this.conItem
        ? this.conItem.text
          ? this.conItem.text.split("\n")
          : []
        : [];
      this.jobItem.descriptions.push({
        title: this.conItem.title,
        text: texts,
        textStr: this.conItem.text,
      });
      this.conAddVisible = false;
      this.conItem = {
        title: "",
        text: "",
      };
    },
    deleteTagItem(str) {
      this.jobItem.descriptions = this.jobItem.descriptions.filter(
        (i) => i.title !== str
      );
    },
    subJobDetail() {
      if (!this.jobItem.name) {
        ElMessage.error("没填岗位名称，无法提交岗位信息！");
        return;
      }
      if (this.jobItem.momey) {
        const regex = /^-?\d+(\.\d+)?([eE][-+]?\d+)?$/;
        if (this.jobItem.momey.includes("-")) {
          const arr = this.jobItem.momey.split("-");
          if (arr.length > 2) {
            ElMessage.error("岗位新增填写有误，请重新填写:如 4-6 或者4！");
            return;
          }
          if (!regex.test(arr[0])) {
            ElMessage.error("岗位新增填写有误，请重新填写:如 4-6 或者4！");
            return;
          }
          if (!regex.test(arr[1])) {
            ElMessage.error("岗位新增填写有误，请重新填写:如 4-6 或者4！");
            return;
          }
        } else {
          if (!regex.test(this.jobItem.momey)) {
            ElMessage.error("岗位新增填写有误，请重新填写:如 4-6 或者4！");
            return;
          }
        }
      }
      const jobDto = {
        id: this.jobItem.id,
        name: this.jobItem.name,
        momey: this.jobItem.momey,
        site: this.jobItem.site,
        exerience: this.jobItem.exerience,
        xueli: this.jobItem.xueli,
        content: "",
        demand: "",
        usCompanyType: this.isKK ? 1 : 2,
      };
      if (this.jobItem.tags) {
        jobDto.demand = this.jobItem.tags.join("——");
      }
      if (this.jobItem.descriptions) {
        const jobArr = [];
        this.jobItem.descriptions.forEach((vo) => {
          jobArr.push(vo.title + "~" + vo.textStr);
        });
        jobDto.content = jobArr ? jobArr.join("——") : "";
      }
      // 提交数据到接口
      axios
        .post("/job/save", jobDto, {
          Headers: {
            "Content-Type": "application/json;charset=utf-8",
          },
        }) // 使用创建的api实例: api.post('/your-endpoint', payload)
        .then((response) => {
          // 处理接口返回的结果
          if (response.data.code === 200) {
            this.jobItem = {
              id: "",
              name: "",
              momey: "",
              site: "",
              exerience: "",
              xueli: "",
              content: "",
              demand: "",
              tags: [],
              descriptions: [],
            };
            this.jobVisible = false;
            this.queryJobs();
          } else {
            ElMessage.error("岗位上传失败" + response.data.message);
          }
        })
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("岗位上传失败", error);
        });
    },
    deleteJob() {
      this.$confirm("此操作将移除岗位, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 提交数据到接口
          axios
            .get("/job/delete", {
              params: { Id: this.jobItem.id },
            }) // 使用创建的api实例: api.post('/your-endpoint', payload)
            .then((response) => {
              // 处理接口返回的结果
              if (response.data.code === 200) {
                this.$message({
                  type: "success",
                  message: "岗位移除成功!",
                });
                this.jobVisible = false;
                this.queryJobs();
              } else {
                ElMessage.error("岗位失败：" + response.data.description);
              }
            })
            .catch((error) => {
              // 处理请求错误
              ElMessage.error("请求失败，请检查网络或接口地址");
              console.error("岗位移除失败：", error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消岗位移除",
          });
        });
    },
    queryJobs() {
      const jobDto = {
        usCompanyType: this.isKK ? 1 : 2,
      };
      axios
        .post("/job/query", jobDto, {
          Headers: {
            "Content-Type": "application/json;charset=utf-8",
          },
        }) // 使用创建的api实例: api.post('/your-endpoint', payload)
        .then((response) => {
          // 处理接口返回的结果
          if (response.data.code === 200) {
            this.jobs = response.data.data;
          }
        })
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("提交失败：", error);
        });
    },
    getJobDetail(id) {
      axios
        .get("/job/get", {
          params: { Id: id },
        }) // 使用创建的api实例: api.post('/your-endpoint', payload)
        .then((response) => {
          // 处理接口返回的结果
          if (response.data.code === 200) {
            this.jobItem = response.data.data;
          } else {
            ElMessage.error("数据获取失败：" + response.data.description);
          }
        })
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("数据获取失败：", error);
        });
    },
    joinChange() {
      this.joinFrom = {
        name: "",
        contact: "",
      };
    },
    beforeUpload(file) {
      if (!file) {
        this.$message.error("文件丢失取消上传");
        return false;
      } else if (file.size / 1024 / 1024 > 50) {
        this.$message.error("文件不能大雨50M");
        return false;
      }
      try {
        var fileReader = new FileReader();
        //获取文件二进制数据
        fileReader.readAsArrayBuffer(file);
        const spark = new SparkMD5.ArrayBuffer();
        fileReader.onload = async (e) => {
          spark.append(e.target.result);
          this.fileDate.MD5 = spark.end();
          this.localUpload(file, this.fileDate.MD5);
        };
      } catch (error) {
        console.error("计算MD5值有误：", error);
        return false;
      }
      return false;
    },
    handleChange(file, fileList) {
      console.log("file------", file);
      console.log("filelist-------", fileList.slice(-3));
    },
    //上传文件到本地服务器
    localUpload(file, MD5) {
      const fileType = file.name.split(".")[1];
      const formData = new FormData();
      formData.append("file", file);
      formData.append("md5", MD5);
      formData.append("category", "resume");
      formData.append("size", file.size);
      formData.append("originalName", file.name);
      formData.append("type", fileType);
      formData.append("method", 0);
      formData.append("attachNo", this.fileDate.attachNo);
      formData.append("oldId", this.fileDate.oldId);
      formData.append("oldPath", this.fileDate.oldPath);
      formData.append("status", this.fileDate.status);
      formData.append("id", this.fileDate.id);
      // 提交数据到接口
      axios
        .post("/attachment/localUpload/nocheck", formData, {
          Headers: {
            "Content-Type": "multipart/form-data",
          },
        }) // 使用创建的api实例: api.post('/your-endpoint', payload)
        .then((response) => {
          // 处理接口返回的结果
          if (response.data.code === 200) {
            ElMessage.success("上传成功");
            // this.imageUrl = response.data.data.path;
            this.fileDate.oldPath = response.data.data.path;
            this.fileDate.oldId = response.data.data.id;
            this.fileDate.id = response.data.data.id;
            this.fileDate.status = 2;
            this.fileList = [
              {
                name: response.data.data.originalName,
                url: response.data.data.path,
              },
            ];
          } else {
            ElMessage.error("上传失败：" + response.data.message);
          }
        })
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("上传失败：", error);
        });
    },
    submitJoin(Ref) {
      this.$refs[Ref].validate((valid) => {
        if (valid) {
          // 提交数据到接口
          const messageDto = {
            name: this.joinFrom.name,
            contact: this.joinFrom.contact,
            attachmentId: this.fileDate.id,
            type: 1,
            usCompanyType: this.isKK ? 1 : 2,
          };
          // 提交数据到接口
          axios
            .post("/message/add", messageDto, {
              Headers: {
                "Content-Type": "application/json;charset=utf-8",
              },
            }) // 使用创建的api实例: api.post('/your-endpoint', payload)
            .then((response) => {
              // 处理接口返回的结果
              if (response.data.code === 200) {
                ElMessage.success("留言成功");
                this.joinChange();
                this.setFileStatus();
              } else {
                ElMessage.error("留言失败" + response.data.description);
              }
            })
            .catch((error) => {
              // 处理请求错误
              ElMessage.error("请求失败，请检查网络或接口地址");
              console.error("留言失败", error);
            });
        } else {
          ElMessage.error("请填写所有必填项");
          return false;
        }
      });
    },
    setFileStatus() {
      this.fileDate.oldPath = "";
      this.fileDate.oldId = "";
      this.fileDate.id = "";
      this.fileDate.MD5 = "";
      this.fileDate.status = 1;
      this.fileList = [];
    },
    dowloadFile() {
      // 提交数据到接口
      console.log("这边暂时不提供下载入口！");
      // axios({
      //   method: "post",
      //   url: "/attachment/downLoad",
      //   params: {
      //     path: this.fileList[0].url,
      //     name: this.fileList[0].name,
      //   },
      //   responseType: "blob",
      // })
      //   .then((res) => {
      //     const blob = new Blob([res.data], { type: res.data.type });
      //     const elink = document.createElement("a");
      //     //创建下载链接
      //     elink.href = window.URL.createObjectURL(blob);
      //     //下载后文件名
      //     elink.download = this.fileList[0].name;
      //     document.body.appendChild(elink);
      //     //点击下载
      //     elink.click();
      //     // 下载完成移除元素
      //     document.body.removeChild(elink);
      //     // 释放掉blob对象
      //     window.URL.revokeObjectURL(elink.href);
      //     ElMessage.success("下载成功");
      //   })
      //   .catch((error) => {
      //     // 处理请求错误
      //     ElMessage.error("请求失败，请检查网络或接口地址");
      //     console.error("留言失败", error);
      //   });
    },
  },
};
</script>
<template>
  <div class="US_banner">
    <div>
      <img v-if="this.isKK" src="../assets/women.png" />
      <img v-else src="../assets/L1.jpeg" />
    </div>
  </div>
  <div class="back">
    <div
      v-if="this.jobs.length != 0 || this.isZ"
      class="title"
      style="width: 90%; margin: auto"
    >
      <span class="line"></span>
      <span>岗位信息</span>
    </div>
    <div class="jobPost" v-if="this.jobs || this.isZ">
      <div class="flex line">
        <div
          v-for="(item, index) in jobs"
          :key="item.id"
          :style="{ width: (inner_width - 10) / 4 + 'px' }"
          class="jobPost_box"
        >
          <div class="jobPost_item_split"></div>
          <div
            class="jobPost_item"
            @click="openAddJop(item.id)"
            :style="{
              width:
                inner_width / 4 -
                (index == 0 || index == this.jobs.length - 1 ? 15 : 30) +
                'px',
            }"
          >
            <div class="header flex">
              <div class="jobgw_name">{{ item.name }}</div>
              <div class="jobgw_momey" v-if="item.momey">{{ item.momey }}k</div>
            </div>
            <div class="tag flex">
              <div class="tag_item" v-if="item.site">
                <img class="min-logo" src="../assets/gzdz.png" />{{ item.site }}
              </div>
              <div class="tag_item" v-if="item.exerience">
                <img class="min-logo" src="../assets/gzjy.png" /> {{ item.exerience }}
              </div>
              <div class="tag_item" v-if="item.xueli">
                <img class="min-logo" src="../assets/xl.png" /> {{ item.xueli }}
              </div>
            </div>
          </div>
          <div class="jobPost_item_split"></div>
        </div>
        <div
          v-if="this.isZ"
          :style="{ width: (inner_width - 10) / 4 + 'px' }"
          class="jobPost_box"
        >
          <div class="jobPost_item_split"></div>
          <div class="jobPost_item" @click="openAddJop()">
            <img class="jobPost_addBtn" src="../assets/addbig.png" />
          </div>
        </div>
        <el-dialog
          v-model="jobVisible"
          width="50%"
          style="max-height: 700px; overflow-y: auto; background: #fafafa"
          center
        >
          <div class="guozuo">
            <div class="guozuo_heard flex">
              <div class="guozuo_title">
                <el-input
                  v-if="this.isZ"
                  v-model="this.jobItem.name"
                  placeholder="请输入工作岗位"
                />
                <span v-else> {{ this.jobItem.name }}</span>
              </div>
              <div class="guozuo_momey flex" v-if="this.jobItem.momey || this.isZ">
                <el-input
                  v-if="this.isZ"
                  v-model="this.jobItem.momey"
                  placeholder="请输入薪资"
                />
                <span v-else> {{ this.jobItem.momey }}</span
                >k
              </div>
            </div>
            <div class="guozuo_tag flex">
              <div class="tag_item" v-if="this.jobItem.site || this.isZ">
                <img class="min-logo" src="../assets/gzdz.png" />
                <el-input
                  v-if="this.isZ"
                  v-model="this.jobItem.site"
                  placeholder="请输入工作地点"
                  style="vertical-align: middle"
                />
                <span v-else> {{ this.jobItem.site }}</span>
              </div>
              <div class="tag_item" v-if="this.jobItem.exerience || this.isZ">
                <img class="min-logo" src="../assets/gzjy.png" />
                <el-input
                  v-if="this.isZ"
                  v-model="this.jobItem.exerience"
                  placeholder="请输入需要工作经验"
                  style="vertical-align: middle"
                />
                <span v-else> {{ this.jobItem.exerience }}</span>
              </div>
              <div class="tag_item" v-if="this.jobItem.xueli || this.isZ">
                <img class="min-logo" src="../assets/xl.png" />
                <el-input
                  v-if="this.isZ"
                  v-model="this.jobItem.xueli"
                  placeholder="请输入需要学历"
                  style="vertical-align: middle"
                />
                <span v-else> {{ this.jobItem.xueli }}</span>
              </div>
            </div>
            <div class="guozuo-content">
              <div class="con_title">职务描述</div>
              <div class="con_tag flex">
                <div v-for="tagStr in this.jobItem.tags" :key="tagStr" class="tag_item">
                  <div class="tagStr">{{ tagStr }}</div>
                  <el-button
                    v-if="this.isZ"
                    type="info"
                    circle
                    style="width: 1px; height: 1px"
                    @click="deleteTag(tagStr)"
                  >
                  </el-button>
                </div>
              </div>
              <el-button
                v-if="this.isZ"
                type="primary"
                @click="openAddTag()"
                style="width: 100%; margin-top: 10px; margin-bottom: 10px"
                round
                >添加标签</el-button
              >
              <div
                class="con_for"
                v-for="itemDto in this.jobItem.descriptions"
                :key="itemDto.title"
              >
                <div class="item_title">【{{ itemDto.title }}】</div>
                <ul>
                  <li class="item_cont" v-for="(dto, index) in itemDto.text" :key="dto">
                    {{ index + 1 }}、{{ dto }}
                  </li>
                </ul>
                <el-button
                  v-if="this.isZ"
                  type="info"
                  circle
                  style="width: 1px; height: 1px"
                  class="item_cont_btn"
                  @click="deleteTagItem(itemDto.title)"
                >
                </el-button>
              </div>
            </div>
            <el-button
              v-if="this.isZ"
              type="primary"
              @click="openAddCon()"
              style="width: 100%; margin-top: 10px; margin-bottom: 10px"
              round
              >添加内容</el-button
            >
            <div v-if="this.isZ" class="gw-footer">
              <el-button
                type="primary"
                @click="subJobDetail()"
                style="height: 30px; width: 14%; font-size: 16px; margin: auto"
                round
                >提交岗位信息</el-button
              >
              <el-button
                v-if="this.jobItem.id"
                type="danger"
                @click="deleteJob()"
                style="height: 30px; width: 14%; font-size: 16px; margin-left: 20px"
                round
                >移除岗位</el-button
              >
            </div>
          </div>
        </el-dialog>
        <el-dialog v-model="tagAddVisible" title="添加标签" width="40%" center>
          <el-input
            v-if="this.isZ"
            v-model="this.tagItem"
            placeholder="请输入需要添加的标签"
          />
          <div class="tag-footer">
            <el-button
              type="primary"
              @click="subTag()"
              style="height: 30px; width: 20%; font-size: 16px; margin: auto"
              round
              >确认添加</el-button
            >
          </div>
        </el-dialog>
        <el-dialog v-model="conAddVisible" title="添加内容" width="40%" center>
          <el-input v-model="this.conItem.title" placeholder="请输入需要添加的内容标题" />
          <el-input
            v-model="this.conItem.text"
            placeholder="请输入需要添加的内容标题"
            type="textarea"
            style="margin-top: 10px"
            :rows="5"
          />
          <div class="tag-footer">
            <el-button
              type="primary"
              @click="submitTagItem()"
              style="height: 30px; width: 20%; font-size: 16px; margin: auto"
              round
              >确认添加</el-button
            >
          </div>
        </el-dialog>
      </div>
    </div>
    <div class="title" style="width: 90%; margin: auto">
      <span class="line"></span>
      <span>加入我们</span>
    </div>
    <div class="join">
      <div class="join-us">
        <div class="join-title">诚招英才</div>
        <div class="join-content">
          <div class="text">
            公司热切欢迎怀揣梦想、致力于在智能制造前沿与自动化管理创新领域深耕细作的优秀人才加入我们，在这里，您将有机会与行业顶尖团队并肩作战，共同塑造未来制造与供应链的全新格局。
            我们提供广阔的发展平台、有竞争力的薪酬福利以及开放包容的工作环境，助力您的职业生涯迈向新高度。
          </div>
          <div class="file">
            <el-form :model="joinFrom" :rules="rules2" ref="joinFrom">
              <el-form-item
                label="名称："
                prop="name"
                label-width="120px"
                style="height: 50px"
              >
                <el-input
                  v-model="joinFrom.name"
                  placeholder="您的名字"
                  style="height: 50px"
                />
              </el-form-item>
              <el-form-item
                label="联系电话："
                prop="contact"
                label-width="120px"
                style="height: 50px"
              >
                <el-input
                  v-model="joinFrom.contact"
                  placeholder="您的电话"
                  style="height: 50px"
                />
              </el-form-item>
              <el-upload
                v-model="joinFrom.file"
                :limit="1"
                :before-upload="beforeUpload"
                :on-change="handleChange"
                :on-preview="dowloadFile"
                :file-list="this.fileList"
                action="file/path"
                class="upload-demo"
                accept=".pdf,.doc"
              >
                简历投递
              </el-upload>
            </el-form>
            <div class="join-footer">
              <el-button
                type="primary"
                @click="submitJoin('joinFrom')"
                style="height: 50px; width: 40%; font-size: 20px"
                >提交信息</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="title" style="width: 90%; margin: auto">
      <span class="line"></span>
      <span>公司地址</span>
    </div>
    <div class="map">
      <div class="flex map-content">
        <div v-if="this.isKK" class="main-map">
          <mainMap
            content="福建科控自动化科技有限公司"
            centerlat="24.522969"
            centerlng="117.619038"
          ></mainMap>
        </div>
        <div v-else class="main-map">
          <mainMap
            content="北京凯创通达科技有限公司"
            centerlat="39.914002"
            centerlng="116.469803"
          ></mainMap>
        </div>
        <div class="map-item">
          <div class="map-title">{{ this.name }}</div>
          <div>
            <ul>
              <li>电话：{{ this.phone }}</li>
              <li>邮箱：{{ this.email }}</li>
              <li>地址：{{ this.site }}</li>
              <div style="width: 100%"><img src="../assets/wx_ewm.png" /></div>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.US_banner {
  width: 100%;
  height: 500px;
}
.US_banner img {
  width: 100%;
  height: 500px;
  /* filter: opacity(25%); */
}
.back {
  width: 100%;
  /* background-image: url("../assets/about.jpg"); */
  background-size: cover;
  background-position: center;
  background-color: rgba(6, 93, 255, 0.1);
  padding-top: 15px;
}

.join {
  margin: auto;
  width: 80%;
  list-style: none;
  padding-top: 30px;
  padding-bottom: 30px;
}
.join-us {
  width: 100%;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 10px;
  padding-right: 10px;
  /* background: #ffffff; */
  background: rgb(255, 255, 255, 0.8);
  width: 100%;
  border-radius: 3px;
  border: 2px solid #efefef;
}
.join-title {
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  color: #535353;
  padding-bottom: 10px;
}
.join-content {
  font-size: 16px;
  color: #535353;
  padding-bottom: 10px;
}
.file {
  text-align: center;
  padding-top: 50px;
  margin: auto;
  width: 80%;
}
.join-footer {
  padding-top: 20px;
}
.jobPost {
  margin: auto;
  width: 80%;
  list-style: none;
  padding-top: 30px;
  padding-bottom: 30px;
}
.jobPost_box {
  display: flex;
}
.jobPost .line {
  flex-wrap: wrap;
}
.jobPost .line .jobPost_item {
  background: rgb(255, 255, 255, 0.8);
  border-radius: 3px;
  border: 2px solid #efefef;
  cursor: pointer;
  box-shadow: 0 0 1px 2px rgba(0, 0, 0, 0.1);
  padding: 5px;
  margin-bottom: 16px;
}
.jobPost .line .jobPost_item:hover {
  box-shadow: 0 0 3px 5px rgba(41, 148, 248, 0.3);
}
.jobPost_addBtn {
  width: 100%;
  height: 100%;
}
.jobPost_item_split {
  width: 8px;
}
.header {
  padding-bottom: 10px;
}
.jobgw_name {
  width: 80%;
  margin-right: 10px;
  font-weight: 600;
  font-size: 20px;
  height: 40px;
  line-height: 40px;
  color: #2b2a2a;
}
.jobgw_momey {
  width: 18%;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  font-weight: 400;
}
.tag {
  padding-bottom: 10px;
}
.guozuo_heard {
  width: 100%;
  margin-top: 20px;
}
.guozuo_title {
  width: 86%;
  margin-right: 10px;
  font-weight: 800;
  font-size: 24px;
  height: 40px;
  line-height: 40px;
}
.guozuo_momey {
  width: 12%;
  color: #f72828;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  font-weight: 600;
}
.guozuo_tag {
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
}
.tag_item {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  /* width: 32%; */
  margin-left: 20px;
  border-radius: 3px;
  border: 2px solid #efefef;
  background: rgba(196, 196, 196, 0.08);
  height: 20px;
  line-height: 20px;
  padding-right: 5px;
}
.tag_item .tagStr {
  margin-right: 2px;
  padding-left: 5px;
  padding-top: 1px;
  padding-bottom: 1px;
}
.tag_item .min-logo {
  width: 15px;
  height: 15px;
  padding-top: 3px;
  padding-left: 5px;
  vertical-align: middle;
}
.con_tag {
  margin-top: 20px;
  margin-bottom: 20px;
}
.guozuo-content .con_title {
  font-weight: 600;
  font-size: 20px;
  margin-top: 20px;
  margin-bottom: 10px;
}
.gw-footer {
  width: 100%;
  text-align: center;
}
.tag-footer {
  margin-top: 10px;
  width: 100%;
  text-align: center;
}
.item_title {
  font-size: 16px;
  font-weight: 540;
}
.item_cont {
  display: block;
}
.con_for {
  position: relative; /* 设置父元素为相对定位 */
}
.item_cont_btn {
  top: 0%;
  right: 0%;
  width: 5px;
  height: 5px;
  position: absolute;
}
</style>
